// extracted by mini-css-extract-plugin
export default {"card2":"kC46PPrF","image":"FlcqxrBY","headline":"utuoAKQj"};